import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Mail } from 'lucide-react';
export function CTASection() {
  return <section id="cta" className="py-20 md:py-32 bg-[#2D5A27] relative overflow-hidden" data-id="element-17">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-18">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#C5A55A] opacity-10 blur-3xl" data-id="element-19"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#1B2E1B] opacity-40 blur-3xl" data-id="element-20"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight" data-id="element-23">
            YOU'RE ONE STEP AWAY FROM THE LAWN YOU DESERVE
          </h2>

          <p className="text-2xl text-[#C5A55A] font-medium mb-12" data-id="element-24">
            Call, text, or email us right now.
          </p>

          {/* Phone Numbers */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6" data-id="element-25">
            <a href="tel:8325034445" className="w-full sm:w-auto flex items-center justify-center gap-3 bg-white text-[#2D5A27] px-8 py-5 rounded-xl font-black text-2xl md:text-3xl transition-all duration-300 hover:scale-105 shadow-2xl hover:shadow-[0_0_30px_rgba(255,255,255,0.3)]" data-id="element-26">
              <Phone className="w-8 h-8" data-id="element-27" />
              832-503-4445
            </a>
            <a href="tel:8327594597" className="w-full sm:w-auto flex items-center justify-center gap-3 bg-white/10 border-2 border-white/30 text-white px-8 py-5 rounded-xl font-bold text-xl md:text-2xl transition-all duration-300 hover:scale-105 hover:bg-white/20" data-id="element-28">
              <Phone className="w-7 h-7" data-id="element-29" />
              832-759-4597
            </a>
          </div>

          {/* Text & Email */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-30">
            <a href="sms:8325034445?body=Hi, I'd like a free quote for lawn service" className="w-full sm:w-auto flex items-center justify-center gap-3 bg-[#C5A55A] text-[#1B2E1B] px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 hover:scale-105 hover:bg-[#d4b46a] shadow-lg" data-id="element-31">
              <MessageCircle className="w-6 h-6" data-id="element-32" />
              Text Us for a Quote
            </a>
            <a href="mailto:rmoralesjose06@gmail.com?subject=Free Quote Request&body=Hi, I'd like a free quote for lawn service." className="w-full sm:w-auto flex items-center justify-center gap-3 bg-white/10 border-2 border-[#C5A55A]/50 text-[#C5A55A] px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 hover:scale-105 hover:bg-white/20" data-id="element-33">
              <Mail className="w-6 h-6" data-id="element-34" />
              Email Us
            </a>
          </div>

          <p className="mt-8 text-gray-300 font-medium" data-id="element-35">
            Get your quote in less than 10 minutes.
          </p>
        </motion.div>
      </div>
    </section>;
}